var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLearners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "164px",
    height: "164px",
    viewBox: "0 0 164 164",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "graphic-learners") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finlistics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cd-6",
    transform: "translate(-1577.000000, -1697.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "graphic-learners",
    transform: "translate(1577.000000, 1697.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 82,
    cy: 82,
    r: 82
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(32.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    cx: 52,
    cy: 62,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,70.5 L103.5,70.5 L103.5,2.5 L4,2.5 C3.17157288,2.5 2.5,3.17157288 2.5,4 L2.5,70.5 Z",
    id: "Rectangle",
    stroke: "#0D0D0D",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,52.5 L103,52.5",
    id: "Line-5",
    stroke: "#000000",
    strokeWidth: 5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.343372,113.5 C76.951421,117.027728 75.844843,120.040209 74,122.5 C72.6891412,124.247812 70.6039033,126.237704 67.727768,128.5 L100.793991,128.5 C97.6222345,126.196386 95.3824079,124.229963 94.047828,122.561738 C92.1517499,120.19164 91.031105,117.157716 90.6467597,113.5 L77.343372,113.5 Z",
    id: "Rectangle",
    stroke: "#000000",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 38,
    y: 48,
    width: 92,
    height: 42
  }), /*#__PURE__*/React.createElement("g", {
    id: "users",
    transform: "translate(86.000000, 53.000000)",
    stroke: "#0D0D0D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25,29 L25,25.6666667 C25,21.9847683 22.2017797,19 18.75,19 L6.25,19 C2.79822031,19 0,21.9847683 0,25.6666667 L0,29",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 12.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(23.680851, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3191489,29 L11.3191489,25.9335605 C11.3168828,23.1386814 9.26081357,20.6987192 6.31914894,20",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319148936,0 C3.26131492,0.701682252 5.31914894,3.17108307 5.31914894,6 C5.31914894,8.82891693 3.26131492,11.2983177 0.319148936,12",
    id: "Path"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(45.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.408358,0.710744074 C16.8941569,0.710744074 11.0605844,-0.888430092 7.0985593,0.710744074 C2.4968027,2.56813015 0,7.89820953 0,11.834132 C0,12.0825646 3.76128069,22.9872534 7.0985593,22.9575199 C8.8477787,22.9419353 11.2139651,22.9419353 14.1971186,22.9575199 C14.9386877,22.9436503 24.8084709,25.3100196 27.5069173,22.9575199 C30.9605133,19.9466826 27.3146208,12.0379574 27.5069173,11.834132 C30.6160302,8.53861687 25.5421219,0.710744074 20.408358,0.710744074 Z",
    id: "Oval",
    fill: "#40A4C4",
    opacity: 0.894042969,
    transform: "translate(14.500000, 12.000000) scale(-1, 1) translate(-14.500000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3858351,7 L14.6141649,20",
    id: "Line-4",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    transform: "translate(14.500000, 13.500000) rotate(-90.000000) translate(-14.500000, -13.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5,7 L14.5,20",
    id: "Line-4",
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinecap: "round",
    transform: "translate(14.500000, 13.500000) rotate(-360.000000) translate(-14.500000, -13.500000) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearners);
export default __webpack_public_path__ + "static/media/learners.d45ad9893584e322abf8b7962d527b65.svg";
export { ForwardRef as ReactComponent };